import { Component, OnInit } from '@angular/core';
import { StoreService } from "../../../../core/src/lib/store/store.service";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { SellerLocation } from "@libs/api-models";

export interface LocationGroup {
  ownerSellerID: number | null;
  ownerSellerName: string;
  ownerMerchantID: string;
  locations: SellerLocation[];
}

@Component({
  selector: 'square-pos-integration-manage-locations',
  templateUrl: './manage-locations.component.html',
  styleUrls: ['./manage-locations.component.scss'],
})
export class ManageLocationsComponent implements OnInit {

  locationsForm = new FormGroup({});
  private _locations: SellerLocation[] = [];
  groups: LocationGroup[] = [];

  constructor(
    public store: StoreService
  ) {}

  ngOnInit(): void {
    this.store.sellerLocations$.subscribe((locations) => {
      this._locations = locations;
      Object.keys(this.locationsForm.controls).forEach(key => {
        this.locationsForm.removeControl(key);
      });
      locations.forEach((location) => {
        this.locationsForm.addControl(location.squareID, new FormControl(location.extRef, [Validators.required]));
      });
      this.groups = this.groupBySeller(locations);
    })
  }

  updateLocations() {
    this._locations.forEach((location) => {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      location.extRef = this.locationsForm.get(location.squareID)?.value;
    })
    this.store.updateSellerLocations(this._locations).subscribe(() => {});
  }

  /**
   * Group locations by owning seller so franchise organizations render
   * a section per merchant. Falls back to a single "Locations" bucket
   * when the API hasn't populated owner fields (single-merchant sellers
   * or older responses).
   */
  private groupBySeller(locations: SellerLocation[]): LocationGroup[] {
    if (locations.length === 0) {
      return [];
    }
    const byOwner = new Map<string, LocationGroup>();
    for (const location of locations) {
      const key = location.ownerSellerID != null
        ? String(location.ownerSellerID)
        : 'unknown';
      let group = byOwner.get(key);
      if (!group) {
        group = {
          ownerSellerID: location.ownerSellerID ?? null,
          ownerSellerName: location.ownerSellerName || 'Locations',
          ownerMerchantID: location.ownerMerchantID || '',
          locations: [],
        };
        byOwner.set(key, group);
      }
      group.locations.push(location);
    }
    return Array.from(byOwner.values()).sort((a, b) =>
      a.ownerSellerName.localeCompare(b.ownerSellerName),
    );
  }
}
